<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div class="user-profile-view">
      <dashboard-header
        text="Mój profil"
        :has-slot="true"
      >
        <standard-button
          text="Usuń konto"
          :text-color="primaryColor"
          @buttonClick="openModal"
          custom-class="delete-account-button"
          class-type="secondary"
        />
      </dashboard-header>
      <div class="user-profile-wrapper">
        <user-profile-form />
        <favourite-service-stations />
      </div>
    </div>
  </transition>
</template>

<script>
import DashboardHeader from '~/DashboardHeader';
import UserProfileForm from '~/UserProfileForm';
import StandardButton from '~/StandardButton';
import FavouriteServiceStations from '~/FavouriteServiceStations';
import { mapGetters, mapActions } from 'vuex';
import ajax from '@/helpers/ajax';
import config from '@/config';

export default {
  components: {
    DashboardHeader,
    UserProfileForm,
    StandardButton,
    FavouriteServiceStations,
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
    }),
  },
  methods: {
    ...mapActions({
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      logout: 'auth/logout',
    }),
    deleteAccount() {
      ajax.delete(config.apiEndpoints.deleteUser)
        .then((res) => {
          if (res.status === 200) {
            this.logout();
            this.closeModal();
          }
        });
    },
    openModal() {
      this.setModalContent({
        title: 'Usuwanie konta',
        html: `
          <p class="modal-text">Czy na pewno chcesz dokonać usunięcia swojego konta?</p>
          <p class="modal-text">Uwaga: Akcja jest nieodwracalna. Utracisz wszystkie dane dotyczące Twoich samochodów oraz historię wizyt,
            w tym również tych zbliżających się. Usunięcie konta <strong class="bold">nie spowoduje</strong>
            odwołania aktualnie zaplanowanych wizyt!
          </p>
          `,
        confirm: 'Potwierdzam',
        cancel: 'Anuluj',
      });

      this.setCallback(this.deleteAccount);

      this.toggleModal();
    },
  },
};
</script>
